import React, { useState } from "react";
import { Card, CardContent, Typography, Button, Grid } from "@mui/material";
import LocateLand from "../LocateLand";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ThreeDotMenu from "./Options";
import { acresToHectares } from "../../globals/utils";
import { LoadScript } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "../../globals/const";
const useStyles = makeStyles(() => ({
  title: {
    fontSize: "12px !important",

    fontWeight: "700 !important",
    lineHeight: "18px",
    textAlign: "start",
  },
  value: {
    fontSize: "12px !important",

    fontWeight: "400 !important",
    lineHeight: "18px",
    textAlign: "start",
  },
  fileText: {
    fontSize: "15px !important",
    color: "#827F7F",
    fontWeight: "700 !important",
    lineHeight: "18px",
  },
}));

const FarmCard = ({ farm, onEdit, onDelete }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  const navigate = useNavigate();
  const polygonCoordinates = farm.polygon
    .replace("SRID=4326;POLYGON ((", "") // Remove prefix
    .replace("))", "") // Remove suffix
    .split(", ")
    .map((point) => point.split(" ").map(parseFloat));

  const centerLat =
    polygonCoordinates.reduce((sum, point) => sum + point[0], 0) /
    polygonCoordinates.length;
  const centerLng =
    polygonCoordinates.reduce((sum, point) => sum + point[1], 0) /
    polygonCoordinates.length;

  const handleView = () => {
    navigate(`/farmer/farm/${farm.id}`);
  };

  const handleSatelliteView = () => {
    navigate(`/farmer/satellite-data-farm/${farm.id}`);
  };

  const handleEdit = () => {
    onEdit(farm.id);
  };

  const handleDelete = () => {
    onDelete(farm.id);
  };
  return (
    <Card
      sx={{
        display: "flex",
        // width: "100%",
        height: "100%",
        border: "1px solid #A5A5A5",
      }}
    >
      <Grid container sx={{ padding: "10px" }}>
        <Grid item xs={5} sx={{ width: "100px", height: "130px" }}>
          {farm.polygon && (
            <LoadScript
              googleMapsApiKey={GOOGLE_MAPS_API_KEY}
              onLoad={() => setIsScriptLoaded(true)}
            >
              <LocateLand
                center={{ lat: centerLng, lng: centerLat }}
                setCenter={() => {}}
                path={polygonCoordinates}
                setPath={() => {}}
                editable={false}
                setCurrentLocation={() => {}}
                isScriptLoaded={isScriptLoaded}
              />
            </LoadScript>
          )}
        </Grid>

        <Grid item xs={7}>
          <CardContent>
            <Grid container>
              <Grid item xs={6}>
                <Typography className={classes.title}>
                  {t("Farm Name")}:
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography className={classes.title}>
                  {farm.farm_name}
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ marginTop: "-10px" }}>
                <ThreeDotMenu onEdit={handleEdit} onDelete={handleDelete} />
              </Grid>

              <Grid item xs={6}>
                <Typography className={classes.title}>{t("Area")}:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title}>
                  {farm.area} {t("acres")} ({acresToHectares(farm.area)}{" "}
                  {t("ha")})
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography className={classes.title}>
                  {t("Farm Id")}:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title}>{farm.id}</Typography>
              </Grid>
            </Grid>
          </CardContent>
          <Button
            onClick={handleView}
            style={{
              fontSize: "14px",
              color: "white",
              textTransform: "none",
              width: "170px",
              marginTop: "15px",
              height: "30px",
            }}
            variant="contained"
          >
            {t("View")}
          </Button>
          <Button
            onClick={handleSatelliteView}
            style={{
              fontSize: "14px",
              color: "white",
              textTransform: "none",
              width: "170px",
              marginTop: "15px",
              height: "30px",
            }}
            variant="contained"
          >
            {t("View Satelite Data")}
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default FarmCard;
